import { Component, Injector, OnInit, viewChild } from '@angular/core';
import {
  jkLib,
  idNameItem,
  JkComboboxComponent,
  JkdaterangeComponent,
  jkRestReturn,
  jkRestReturnClass,
} from 'jk-service';
import { MaterialModule } from 'jk-service';
import { StkmbService } from '../services/stkmb.service';
import { SafePipe } from 'safe-pipe';
import {
  JkdatefieldComponent,
} from 'jk-service';
import { SeaFutureOrderComponent } from '../sea-future-order/sea-future-order.component';
import { TwStockOrderComponent } from '../tw-stock-order/tw-stock-order.component';
import { FutureOrderComponent } from '../components/future-order/future-order.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import {
  PassthroughParam,
  stockQuoteColDefs001,
  StockService,
} from '../services/stock.service';
import { ColDef } from 'ag-grid-community';
//import { WebsocketService } from 'jk-service';
import { AdvComModule, jkQueryComponent } from 'jk-advcom';
import { stklg002List } from '../_service_stk';
import { JackBaseComponentModule } from 'jk-service';
import { JkgridwinComponent } from 'jk-advcom';
import { StockQuote } from '../services/stockBase';

export const profitLossList: idNameItem[] = [
  { id: '0', name: '未實現損益' },
  { id: '1', name: '已實現損益' },
  { id: '2', name: '現股當沖' },
];

// 0:彙總 1:明細
export const profitLossFormatList: idNameItem[] = [
  { id: '0', name: '彙總' },
  { id: '1', name: '明細' },
];

@Component({
  selector: 'app-stkpq17',
  standalone: true,
  imports: [
    JackBaseComponentModule,
    AdvComModule,
    MaterialModule,
    SeaFutureOrderComponent,
    TwStockOrderComponent,
    FutureOrderComponent,
    SafePipe,
  ],
  templateUrl: './stkpq17.component.html',
  styleUrl: './stkpq17.component.css',
})
export class Stkpq17Component extends jkQueryComponent implements OnInit {
  //uId: string = '';
  //@ViewChild('kindCom') kindCom!: JkComboboxComponent;
  readonly accountCom = viewChild.required<JkComboboxComponent>('accountCom');
  readonly futureAccountCom = viewChild.required<JkComboboxComponent>('futureAccountCom');
  readonly seaAccountCom = viewChild.required<JkComboboxComponent>('seaAccountCom');
  readonly dateCom = viewChild.required<JkdatefieldComponent>('dateCom');
  readonly daterangeCom = viewChild.required<JkdaterangeComponent>('daterangeCom');
  override _programId = 'stkpq17'; // ### 帳務查詢(STKPQ17)
  isSchedule: boolean = false;
  dateA: string = jkLib.nowDate();
  dateB: string = jkLib.nowDate();
  kind: string = '';
  _kindIndex: number = 0;
  get kindIndex(): number {
    return this._kindIndex;
  }
  set kindIndex(value: number) {
    this._kindIndex = value;
    this.kind = this.kindList[value].id;
    this.kindValueChange(this.kind);
  }
  kindList: idNameItem[] = [
    { id: 'STKLG', name: '報價查詢' },
    //{ id: 'STKLG5', name: '報價5分K線查詢' },
    { id: 'STKMP', name: '上市櫃行情' },
    { id: 'STKMQ', name: '即時證券庫存' },
    { id: 'STKMY', name: '證券集保庫存' },
    { id: 'STOCK', name: '股票損益' },
    { id: 'STKMR', name: '期貨未平倉' },
    /*{ id: 'STKMS', name: '股票未實現損益彙總' },
    { id: 'STKMT', name: '股票未實現損益明細' },
    { id: 'STKMU', name: '股票已實現損益匯總' },
    { id: 'STKMV', name: '股票已實現損益明細' },
     */
    { id: 'STKMX', name: '海期海選未平倉' },
    { id: 'MISC', name: '群益API工具' },
    { id: 'NODE_STOCK', name: '後端重計工具' },
    { id: 'KLINE', name: 'K線資料' },
  ];
  account: string = '';
  futureAccount: string = '';
  seaAccount: string = '';
  get accountList(): idNameItem[] {
    return this.stkmbSrv.accountList;
  }
  get futureAccountList(): idNameItem[] {
    return this.stkmbSrv.futureAccountList;
  }
  get seaAccountList(): idNameItem[] {
    return this.stkmbSrv.seaAccountList;
  }
  _profitLoss: string = '0';
  get profitLoss(): string {
    return this._profitLoss;
  }
  set profitLoss(value: string) {
    this._profitLoss = value;
    if (value === '0') {
      this.daterangeVisible = false;
    } else {
      this.daterangeVisible = true;
    }
  }
  profitLossFormat: string = '0';
  profitLossList = profitLossList;
  profitLossFormatList = profitLossFormatList;
  capitalBalanceUrl: string = `https://tradeweb.capital.com.tw/balance/balance.aspx?foreign=Y&Gopage=1&Func=`;
  date1: string = jkLib.nowDate();
  apiMessage: string = '';

  dateVisible: boolean = false;
  accountVisible: boolean = false;
  futureAccountVisible: boolean = false;
  seaAccountVisible: boolean = false;
  marketVisible: boolean = false;
  groupVisible: boolean = false;
  miscVisible: boolean = false;
  nodeStockVisible: boolean = false;
  kLineVisible: boolean = false;
  stkmqVisible: boolean = false; // 即時證券庫存
  stkmrVisible: boolean = false; // 期貨未平倉
  stkmxVisible: boolean = false; // 海期海選未平倉
  stkmyVisible: boolean = false; // 集保庫存
  //stkmsVisible: boolean = false; // 股票損益
  //stkmuVisible: boolean = false; // 股票已實現損益
  stockVisible: boolean = false; // 股票損益
  stklgVisible: boolean = false; // 報價查詢
  daterangeVisible: boolean = false;
  allOptionHide() {
    this.dateVisible = false;
    this.daterangeVisible = false;
    this.accountVisible = false;
    this.futureAccountVisible = false;
    this.seaAccountVisible = false;
    this.marketVisible = false;
    this.groupVisible = false;
    this.miscVisible = false;
    this.nodeStockVisible = false;
    this.kLineVisible = false;
    this.stkmqVisible = false;
    this.stkmrVisible = false;
    this.stkmxVisible = false;
    this.stkmyVisible = false; // 集保庫存
    //this.stkmsVisible = false; // 股票未實現損益
    //this.stkmuVisible = false; // 股票已實現損益
    this.stockVisible = false; // 股票損益
    this.stklgVisible = false; // 報價查詢
  }
  stockQuoteList: StockQuote[] = [];
  override afterGridReady($event: JkgridwinComponent) {
    super.afterGridReady($event);
  }

  /*stockQuoteGrid!: StockQuoteComponent;
  afterGridReadyStockQuote($event: StockQuoteComponent) {
    this.stockQuoteGrid = $event;
    this.stockQuoteGrid.onFocusedRowChanged = this.rowChange.bind(this); //agRowDoubleClicked.bind(this);
  }
  stockQuoteAfterQuery(list: any) {
    if (list && list.length > 0) {
      if (this.stockNo !== list[0].id) this.stockNo = list[0].id;
    }
  }*/
  rowChange(data: any) {
    //this.changeStock(data);
    console.log('rowChange:', data);
  }
  public stockSrv: StockService = new StockService();
  stkmbSrv: StkmbService = new StkmbService();
  stklg002List = stklg002List;
  _stklg002: string = '日線';
  get stklg002(): string {
    return this._stklg002;
  }
  set stklg002(value: string) {
    this._stklg002 = value;
  }
  get stockNo(): string {
    if (this.stockSrv) return this.stockSrv.stockNo;
    else return '';
  }
  set stockNo(value: string) {
    if (this.stockSrv) {
      this.stockSrv.stockNo = value;
      //this.changeStockById(value);
    }
  }
  //ws: WebsocketService = new WebsocketService(); // TODO:
  constructor() {
    super();
    this.setFormOpt2(); //###
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => {
      if (this.accountList.length > 0) this.account = this.accountList[0].id;
      if (this.futureAccountList.length > 0)
        this.futureAccount = this.futureAccountList[0].id;
      if (this.seaAccountList.length > 0)
        this.seaAccount = this.seaAccountList[0].id;
      //this.kind = 'STKMQ';
      //this.kindValueChange('STKMQ');
      this.kindIndex = 1;
      this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
    }, 1000);
  }
  quoteParam: any[] = [this.date1];

  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();
    try {
      //KLINE K線資料
      if (this.kind === 'KLINE') {
        //this.params
        this.type = 'S';
        this.winItem = 'S05';
        this.mainTable = 'STKLG';
        this.where = '';
        this.where = this.daterangeCom().addWhere(this.where, 'LG001');
      }
      // 上市櫃行情
      if (this.kind === 'STKMP') {
        this.type = 'S';
        this.winItem = '001';
        this.mainTable = 'STKMP';
        this.where = '';
        this.where = this.dateCom().addWhere(this.where, 'MP001');
      }
      // 'STKMQ', name: '即時證券庫存'},
      if (this.kind === 'STKMQ') {
        this.type = 'S';
        this.winItem = '001';
        this.mainTable = this.kind;
        this.where = '';
        this.where = this.accountCom().addWhere(this.where, 'MQ002');
      }
      //{id: 'STKMR', name: '期貨未平倉'},
      if (this.kind === 'STKMR') {
        this.type = 'S';
        this.winItem = '001';
        this.mainTable = 'STKMR';
        this.where = '';
        this.where = this.futureAccountCom().addWhere(this.where, 'MR002');
      }
      //
      if (this.kind === 'STOCK') {
        if (this.profitLoss === '0') {
          //股票未實現
          if (this.profitLossFormat === '0') {
            // 彙總
            this.type = 'S';
            this.winItem = 'S01';
            this.mainTable = 'STKMS'; //'STKMS', name: '股票未實現損益彙總'},
            this.where = '';
            this.where = this.accountCom().addWhere(this.where, 'MS002');
          } else {
            //明細

            this.type = 'S';
            this.winItem = 'S01';
            this.mainTable = 'STKMT'; //{id: 'STKMT', name: '股票未實現損益明細'},
            this.where = '';
            this.where = this.accountCom().addWhere(this.where, 'MT002');
          }
        }
        if (this.profitLoss === '1') {
          // 股票已實現
          //{id: 'STKMU', name: '股票已實現損益匯總'},
          if (this.profitLossFormat === '0') {
            // 彙總
            this.type = 'S';
            this.winItem = 'S01';
            this.mainTable = 'STKMU';
            this.where = '';
            this.where = this.accountCom().addWhere(this.where, 'MU002');
            this.where = this.daterangeCom().addWhere(this.where, 'MU004');
          } else {
            //
            //{id: 'STKMV', name: '股票已實現損益明細'}];
            this.type = 'S';
            this.winItem = 'S01';
            this.mainTable = 'STKMV';
            this.where = ''; // ` AND MV001='${this.dateA}' AND MV002='${this.dateB}'`;
            this.where = this.accountCom().addWhere(this.where, 'MV002');
            this.where = this.daterangeCom().addWhere(this.where, 'MV004');
          }
        }
      }
      // 證券集保庫存 doGetBalanceQuery stkmy
      if (this.kind === 'STKMY') {
        this.type = 'S';
        this.winItem = 'S01';
        this.mainTable = 'STKMY';
        this.where = '';
      }
      if (this.kind === 'STKMX') {
        // 海期海選未平倉
        this.type = 'S';
        this.winItem = 'S01';
        this.mainTable = 'STKMX';
        this.where = '';
        this.where = this.seaAccountCom().addWhere(this.where, 'MX002');
      }
      if (this.kind === 'STKLG') {
        if ((this.stklg002 = '日線')) {
          // 報價日線查詢
          this.type = 'S';
          this.winItem = '002'; //'S04';
          this.mainTable = 'STOCKQUOTE'; //'STKLG';
          this.where = '';
          this.where = this.dateCom().addWhere(this.where, 'LG001');
          this.where += ` AND LG002='日線' AND MF001='${this.stockSrv.groupId}' `;
        }
        if (this.stklg002 === '0005') {
          // 報價5分K線查詢
          this.type = 'S';
          this.winItem = 'S04';
          this.mainTable = 'STKLG';
          this.where = '';
          this.where = this.dateCom().addWhere(this.where, 'LG001');
          this.where += ` AND LG002='0005' AND MF001='${this.stockSrv.groupId}' `;
        }
      }
    } catch (error: any) {
      this.logMessage = JSON.stringify(error);
      return false;
    }

    return true;
  }
  afterQuery() {
    if (this.kind === 'STKLG0') {
      /*this.stockQuoteList = this.masterGrid.itemList;
      this.stockQuoteGrid.itemList = this.stockQuoteList;
      this.stockQuoteGrid.refresh();*/
    }
  }
  /*
  async doUpdateMarket() {
    let body: PassthroughParam = {
      prid: 'getMarket',
    };
    let ret: jkRestReturn = await this.stockSrv.passThrough(body);
    if (ret.result) {
      this.logMessage = ret.message;
      this.page.showToast('查詢成功');
    } else {
      this.logMessage = ret.getResultError();
      await this.page.showAlert('查詢失敗:' + ret.getResultError());
    }
    //this.masterGrid.doQuery2('STKMP','001','S',where);
  }
  */
  async doGetSeaOpenInterest() {
    let seaAccountList = this.idNameItem2String2(this.seaAccountList);
    let body: PassthroughParam = {
      prid: 'GetSeaOpenInterest',
      caption: '海期未平倉更新',
      srvid: 'order',
      uId: this.stkmbSrv.uId,
      seaAccountList: seaAccountList,
      format: 1,
    };
    await this.doPassThrough('GetOpenInterest', body);
  }
  async doGetMarket() {
    let body: PassthroughParam = {
      prid: 'getMarket',
      caption: '更新上市櫃行情',
      srvid: 'quote',
    }; // 更新上市櫃行情
    await this.doPassThrough('getMarket', body);
  }
  async doPassThrough(prid: string, body: any): Promise<jkRestReturn> {
    body.prid = prid;
    let caption = body.caption;
    let ret: jkRestReturn = await this.stockSrv.passThrough(body, this.isSchedule);
    if (this.isSchedule) {
      // TODO:
    } else {
      this.apiMessage = JSON.stringify(ret);
      if (ret.result) {
        this.showToast(caption + '(' + prid + ') 成功');
      } else {
        await this.showAlert(
          caption +
          '(' +
          prid +
          ') 失敗:' +
          ret.message +
          ' ' +
          ret.getResultError()
        );
      }
    }
    return ret;
  }
  onKindTabChange($event: MatTabChangeEvent) {
    this.kindValueChange(this.kindList[$event.index].id);
  }
  kindValueChange($event: string) {
    this.allOptionHide();
    //this.dateCom.visible = false;
    /*if(($event === 'STKMQ') || ($event === 'STKMS') || ($event === 'STKMT') || ($event === 'STKMU') || ($event === 'STKMV')) {
      //this.accountList = this.stkmbSrv.accountList;
      this.account = this.accountList[0].id;
    }
    [{id: 'STKMP', name: '上市櫃行情'},{id: 'STKMQ', name: '即時證券庫存'},{id: 'STKMR', name: '期貨未平倉'},
    {id: 'STKMS', name: '股票未實現損益彙總'},{id: 'STKMT', name: '股票未實現損益明細'},{id: 'STKMU', name: '股票已實現損益匯總'},
    {id: 'STKMV', name: '股票已實現損益明細'},{id: 'STKMY', name: '證券集保庫存'},{id: 'MISC', name: '***其他工具'}];
    */
    if ($event === 'STKMP') {
      // 上市櫃行情
      this.dateVisible = true;
      this.marketVisible = true;
    }
    if ($event === 'STKMQ') {
      // 即時證券庫存
      this.accountVisible = true;
      this.stkmqVisible = true;
    }
    if ($event === 'STKMR') {
      // 期貨未平倉
      this.futureAccountVisible = true;
      this.stkmrVisible = true;
    }
    if ($event === 'STKMX') {
      // 海期海選未平倉
      this.seaAccountVisible = true;
      //this.seaFutureOrderVisible = true;
      this.stkmxVisible = true;
    }
    if ($event === 'STKMY') {
      // 證券集保庫存
      this.accountVisible = true;
      this.stkmyVisible = true;
    }
    if ($event === 'STOCK') {
      // 股票損益
      this.accountVisible = true;
      this.stockVisible = true;
    }
    if (this.kind === 'MISC') {
      // 群益API工具
      this.dateVisible = true;
      //this.daterangeVisible = true;
      this.miscVisible = true;
    }
    if (this.kind === 'NODE_STOCK') {
      // 後端重計工具
      //this.daterangeVisible = true;
      this.nodeStockVisible = true;
    }
    if (this.kind === 'KLINE') {
      // K線資料
      this.dateVisible = true;
      this.daterangeVisible = true;
      this.kLineVisible = true;
    }
    if (this.kind === 'STKLG') {
      // 報價查詢
      this.accountVisible = true;
      this.dateVisible = true;
      this.stklgVisible = true;
      this.groupVisible = true;
    }
  }
  async doRefreshApi() { }
  /** 報價盤後重計 */
  async doAfternoonService() {
    let ret = await this.stockSrv.doAfternoonService(this.date1, this.stkmbSrv);
    if (ret.result) {
      await this.showToast('盤後作業(doAfternoonService)成功');
    } else {
      await this.showAlert(
        '盤後作業(doAfternoonService)失敗:' + ret.getResultError()
      );
    }
  }
  /** 日結帳盤後重計 */
  async doDayCheckoutService() {
    let ret = await this.stockSrv.doDayCheckoutService(
      this.date1,
      this.stkmbSrv
    );
    if (ret.result) {
      await this.showToast('日結帳(doDayCheckoutService)成功');
    } else {
      await this.showAlert(
        '日結帳(doDayCheckoutService)失敗:' + ret.getResultError()
      );
    }
  }

  /** 設股票群組 */
  async doSetGroupId() {
    let body: PassthroughParam = {
      prid: 'setGroupId',
      caption: '設報價股票群組',
      srvid: 'quote',
      groupId: this.stockSrv.groupId,
      mode: 0,
      isMinuteSQL: true,
    };
    let ret = await this.doPassThrough(body.prid, body); //this.stockSrv.passThrough(body);
    this.apiMessage = JSON.stringify(ret);
  }
  /**  查詢證券即時庫存內容 */
  async doGetRealBalanceReport() {
    let accountList = this.idNameItem2String2(this.accountList);
    let body: PassthroughParam = {
      prid: 'GetRealBalanceReport',
      caption: '即時證券庫存',
      srvid: 'order',
      uId: this.stkmbSrv.uId,
      accountList: accountList,
    };
    let ret = await this.doPassThrough(body.prid, body); // this.stockSrv.passThrough(body);
    this.apiMessage = JSON.stringify(ret);
  }
  /** 集保庫存 STKMY */
  async doGetBalanceQuery() {
    let accountList = this.idNameItem2String2(this.accountList);
    let body: PassthroughParam = {
      prid: 'GetBalanceQuery',
      caption: '集保庫存',
      srvid: 'order',
      uId: this.stkmbSrv.uId,
      accountList: accountList,
      stockno: '',
    };
    let ret = await this.doPassThrough(body.prid, body); // this.stockSrv.passThrough(body);
    this.apiMessage = JSON.stringify(ret);
  }
  /**  證券損益試算 */
  async doGetProfitLossGWReport() {
    let accountList = this.idNameItem2String2(this.accountList);
    let body: PassthroughParam = {
      prid: 'GetProfitLossGWReport',
      caption: '證券損益試算',
      srvid: 'order',
      uId: this.stkmbSrv.uId,
      accountList: accountList,
      date1: this.dateA,
      date2: this.dateB,
      ProfitLossIndex: jkLib.fixNumber(this.profitLoss),
      ProfitLossFormatIndex: jkLib.fixNumber(this.profitLossFormat),
    };
    let ret = await this.doPassThrough(body.prid, body); // this.stockSrv.passThrough(body);
    if (this.profitLossFormat === '1') {
      this.showAlert('明細需等待1~5分鐘更新完畢');
    }
    this.apiMessage = JSON.stringify(ret);
  }
  /** 產生股票交易建立 stkta,stktb */
  async doGeneStktatb() {
    let accountList = this.idNameItem2String2(this.accountList);
    let body: PassthroughParam = {
      prid: 'geneStktatb',
      caption: '產生股票交易建立',
      srvid: 'order',
      date1: this.dateA,
      date2: this.dateB,
      accountList: accountList,
    };
    let ret = await this.doPassThrough(body.prid, body); // this.stockSrv.passThrough(body);
    this.apiMessage = JSON.stringify(ret);
  }

  /**  (新)期貨未平倉GW
   */
  async doGetOpenInterest() {
    let futureAccountList = this.idNameItem2String2(this.futureAccountList);
    let body: PassthroughParam = {
      prid: 'GetOpenInterest', //GetOpenInterestWithFormat
      srvid: 'order',
      caption: '期貨未平倉',
      uId: this.stkmbSrv.uId,
      futureAccountList: futureAccountList,
      format: 3,
    };
    let ret = await this.doPassThrough(body.prid, body); // this.stockSrv.passThrough(body);
    this.apiMessage = JSON.stringify(ret);
  }
  stockOrderVisible: boolean = true;
  futureOrderVisible: boolean = false;
  seaFutureOrderVisible: boolean = false;
  /*_orderType: string[] = ['TS'];
  set orderType(value: string[]) {
    //console.log('order type:',value);
    this._orderType = value;
    if (value.includes('TS')) {
      this.stockOrderVisible = true;
    } else {
      this.stockOrderVisible = false;
    }
    if (value.includes('TF')) {
      this.futureOrderVisible = true;
    } else this.futureOrderVisible = false;
    if (value.includes('OF')) {
      this.seaFutureOrderVisible = true;
    } else this.seaFutureOrderVisible = false;
  }
  get orderType() {
    return this._orderType;
  }*/
  orderTypeList: idNameItem[] = [
    { id: 'TS', name: '股票' },
    { id: 'TF', name: '期貨' },
    { id: 'OF', name: '海期' },
  ];
  _orderType: string = 'TS';
  get orderType(): string {
    return this._orderType;
  }
  set orderType(value: string) {
    this._orderType = value;
    if (value === 'TS') {
      this.stockOrderVisible = true;
      this.futureOrderVisible = false;
      this.seaFutureOrderVisible = false;
    } else if (value === 'TF') {
      this.stockOrderVisible = false;
      this.futureOrderVisible = true;
      this.seaFutureOrderVisible = false;
    } else if (value === 'OF') {
      this.stockOrderVisible = false;
      this.futureOrderVisible = false;
      this.seaFutureOrderVisible = true;
    }
  }
  async doOneKeyBeforeOrder() {
    this.doGetMarket();
    this.doGetRealBalanceReport();
    this.doGetBalanceQuery();
    /*       date1: this.dateA,
      date2: this.dateB,
      ProfitLossIndex: jkLib.fixNumber(this.profitLoss),
      ProfitLossFormatIndex: jkLib.fixNumber(this.profitLossFormat),
    */
    this.profitLoss = '0'; // 未實現損益
    this.profitLossFormat = '0'; // 彙總
    this.doGetProfitLossGWReport();
    this.doGetOpenInterest(); // 期貨未平倉
    this.showToast('請等待三分鐘更新完畢');
  }
  doStkpq08() {
    this.navigateTo('stkpq08');
  }
  afterColumnDefs($event: ColDef[]) {
    // 股票報價欄位設定
    if (this.kind === 'STKLG') {
      let quoteCols = stockQuoteColDefs001;
      for (let i = 0; i < $event.length; i++) {
        let field = $event[i].field;
        let col = quoteCols.find((item) => item.field === field);
        if (col) {
          /*width: 72,
        cellDataType: 'number',
        cellRenderer: AgStockQuoteCellView,*/
          $event[i].headerName = col.headerName;
          $event[i].width = col.width;
          $event[i].cellDataType = col.cellDataType;
          if (col.cellRenderer) $event[i].cellRenderer = col.cellRenderer;
        }
      }
    }
  }
}
